import React, { useEffect, useState } from "react";
import BoardCss from "./board.css";
import Data from "../Data/Data";
import Paginate from "./Paginate";
import { Link, useRouteMatch } from "react-router-dom";
import Pagination from "react-js-pagination";

const BoardList = ({ BoardType, BoardData }) => {
  const match = useRouteMatch();
  const [page, setPage] = useState(1);
  const [boardArray, setBoardArray] = useState({
    data: Data,
    pageSize: 10,
    currentPage: 1
  });
  // BoardList를 부르는 Component에서 게시글을 보낼줄 때는 해당 데이터를 사용
  useEffect(() => {
    if (BoardData) {
      setBoardArray({
        data: BoardData,
        pageSize: 10,
        currentPage: 1
      });
    }
  }, []);

  const handlePageChange = page => {
    setBoardArray({ ...boardArray, currentPage: page });
    setPage(page);
  };

  const { data, pageSize, currentPage } = boardArray;
  const pagedData = Paginate(data, currentPage, pageSize);

  const { length: count } = boardArray.data;
  if (count === 0) {
    return <p>게시글이 없습니다.</p>;
  }

  return (
    <BoardCss.BoardContainer>
      <table>
        <colgroup>
          <col width="7%"></col>
          <col width="50%"></col>
          <col width="10%"></col>
          <col width="10%"></col>
        </colgroup>
        <thead>
          <tr>
            <th>번호</th>
            <th>제목</th>
            <th>작성자</th>
            <th>날짜</th>
          </tr>
        </thead>
        <tbody>
          {pagedData.map(board => (
            <tr key={board.idx}>
              <td>{board.idx}</td>
              <td className="boardtitle">
                <Link to={`${match.path}/detail/${board.idx}`}>
                  {board.password ? (
                    <img
                      src="https://img.icons8.com/color/15/000000/lock--v1.png"
                      alt="Lock"
                    />
                  ) : null}
                  {board.title}
                </Link>
              </td>
              <td>{board.createuser}</td>
              <td>{board.createat}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <BoardCss.PaginationContainer>
        <Pagination
          activePage={page}
          itemsCountPerPage={10}
          totalItemsCount={Data.length}
          pageRangeDisplayed={10}
          prevPageText={"<"}
          nextPageText={">"}
          itemClassFirst="Button"
          itemClassPrev="Button"
          itemClassNext="Button"
          itemClassLast="Button"
          onChange={handlePageChange}
          activeLinkClass="ActivePage"
        />
      </BoardCss.PaginationContainer>
      {BoardType === "Take" || BoardType === "Get" ? (
        <div className="BoardWriteBtn">
          <Link to={`${match.path}/write`}>등록</Link>
        </div>
      ) : null}
    </BoardCss.BoardContainer>
  );
};

export default BoardList;
